import api from '../../../../api/client';

export const COMPANY_OPTIONS = [
  { value: 0, label: 'All Companies' },
];

export const BRANCH_OPTIONS = [
  { value: 0, label: 'All Branches' },
];

export const DEPARTMENT_OPTIONS = [
  { value: 0, label: 'All Departments' },
];

export const ATTENDANCE_STATUS_OPTIONS = [
  { value: 'All', label: 'Select (All)' },
  { value: 'P', label: 'Present (P)' },
  { value: 'A', label: 'Absent (A)' },
  { value: 'WO', label: 'Weekly Off (WO)' },
  { value: 'HL', label: 'Holiday (HL)' },
  { value: 'HF', label: 'Half Day (HF)' },
  { value: 'L', label: 'Late In (L)' },
  { value: 'EG', label: 'Early Go (EG)' },
  { value: 'CL', label: 'Casual Leave (CL)' },
  { value: 'EL', label: 'Earned Leave (EL)' },
  { value: 'PL', label: 'Privilege Leave (PL)' },
  { value: 'ML', label: 'Maternity Leave (ML)' },
  { value: 'SL', label: 'Sick Leave (SL)' },
];

export const SEARCH_FIELD_OPTIONS = [
  { value: 'Name', label: 'Employee Name / Code' },
];

export const STATUS_OPTIONS = [
  { value: 'All', label: 'All Status' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];

export const TOOLS_OPTIONS = [
  { key: 'print', label: 'Print Report', icon: 'print' },
  { key: 'export_excel', label: 'Export Excel', icon: 'description' },
  { key: 'export_pdf', label: 'Export PDF', icon: 'picture_as_pdf' },
  { key: 'rollback', label: 'Rollback Process', icon: 'history', danger: true },
];

export const DAILY_ATTENDANCE_PREDEFINED_REPORTS = [
  {
    reportKey: 'daily_attendance_report',
    title: 'Daily Attendance Report',
    description: 'Detailed chronological daily attendance report with biometric punch times, working hours, and attendance status.',
    defaultColumns: ['Emp Code', 'Employee Name', 'Company', 'Branch', 'Department', 'Date', 'First Swipe', 'Last Swipe', 'Working Hours', 'Attendance Status'],
  },
  {
    reportKey: 'daywise_attendance_matrix',
    title: 'Day-wise Attendance Report',
    description: 'Monthly day-wise attendance matrix (Days 1–31) with present, absent, late, and half-day summaries.',
    defaultColumns: ['Emp Code', 'Employee Name', 'Company', 'Branch', 'Department', 'Day 1..31', 'Present', 'Absent', 'Late', 'Half Day'],
  },
  {
    reportKey: 'daily_overtime_report',
    title: 'Daily Overtime Report',
    description: 'Daily overtime tracking reconciling scheduled shift hours against punch timestamps and overtime minutes.',
    defaultColumns: ['Emp Code', 'Employee Name', 'Company', 'Branch', 'Department', 'Date', 'Shift In', 'Shift Out', 'First Swipe', 'Last Swipe', 'Overtime'],
  },
];

function mapItem(i) {
  const rawDate = i.ADate || i.aDate || i.date || '';
  const dateStr = typeof rawDate === 'string' ? rawDate.split('T')[0] : '';
  const dateDisplay = dateStr ? dateStr.split('-').reverse().join('/') : '';
  const att = (i.Attendance || i.attendance || 'A').trim();

  return {
    id: i.ID ?? i.id,
    empId: i.emp_code || i.EmpCode || (i.EmpID ? `EMP-${i.EmpID}` : '-'),
    name: i.emp_name || i.EmployeeName || i.name || '-',
    company: i.company_name || i.CompanyName || '-',
    branch: i.branch_name || i.BranchName || '-',
    department: i.department_name || i.DepartmentName || '-',
    date: dateStr,
    dateDisplay,
    firstSwipe: i.FirstSwipe || i.firstSwipe || '--:--',
    lastSwipe: i.LastSwipe || i.lastSwipe || '--:--',
    totalHours: i.TotalHours || i.totalHours || '--',
    attendance: att,
    status: 'Active',
  };
}

export const dailyProcessApi = {
  getFilterOptions: async () => {
    const { data } = await api.get('/payroll/daily-process/options');
    return data;
  },

  getRecords: async (filters = {}) => {
    const params = {
      from_date: filters.fromDate || filters.from_date || filters.date || undefined,
      to_date: filters.toDate || filters.to_date || filters.date || undefined,
      company_id: filters.company && filters.company !== 'All' && Number(filters.company) > 0 ? Number(filters.company) : undefined,
      branch_id: filters.branch && filters.branch !== 'All' && Number(filters.branch) > 0 ? Number(filters.branch) : undefined,
      dept_id: filters.department && filters.department !== 'All' && Number(filters.department) > 0 ? Number(filters.department) : undefined,
      emp_id: filters.employee && filters.employee !== 'All' && Number(filters.employee) > 0 ? Number(filters.employee) : undefined,
      emp_group_id: filters.group && filters.group !== 'All' && Number(filters.group) > 0 ? Number(filters.group) : undefined,
      gender: filters.gender && filters.gender !== 'All' ? filters.gender : undefined,
      search: filters.search?.trim() || filters.searchText?.trim() || undefined,
      attendance: filters.attendance && filters.attendance !== 'All' ? filters.attendance : (filters.status && filters.status !== 'All' ? filters.status : undefined),
      page: filters.page || 1,
      page_size: filters.pageSize || 50,
    };
    const { data } = await api.get('/payroll/daily-process/', { params });
    const items = Array.isArray(data?.items) ? data.items : [];
    return {
      items: items.map(mapItem),
      total: data?.total || items.length,
      page: data?.page || 1,
      pageSize: data?.page_size || 50,
    };
  },

  getDailyProcessReport: async (filters = {}) => {
    const res = await dailyProcessApi.getRecords({ ...filters, page: 1, pageSize: 5000 });
    return res.items;
  },

  fetchReportData: async (reportKey, filters = {}) => {
    const params = {
      from_date: filters.fromDate || filters.from_date || filters.date || undefined,
      to_date: filters.toDate || filters.to_date || filters.date || undefined,
      company_id: filters.company && filters.company !== 'All' && Number(filters.company) > 0 ? Number(filters.company) : undefined,
      branch_id: filters.branch && filters.branch !== 'All' && Number(filters.branch) > 0 ? Number(filters.branch) : undefined,
      dept_id: filters.department && filters.department !== 'All' && Number(filters.department) > 0 ? Number(filters.department) : undefined,
      emp_id: filters.employee && filters.employee !== 'All' && Number(filters.employee) > 0 ? Number(filters.employee) : undefined,
      emp_group_id: filters.group && filters.group !== 'All' && Number(filters.group) > 0 ? Number(filters.group) : undefined,
      gender: filters.gender && filters.gender !== 'All' ? filters.gender : undefined,
      search: filters.search?.trim() || filters.searchText?.trim() || undefined,
      attendance: filters.attendance && filters.attendance !== 'All' ? filters.attendance : undefined,
    };
    const { data } = await api.get(`/payroll/daily-process/reports/${reportKey}`, { params });
    return data;
  },

  runDailyProcess: async (payload) => {
    const body = {
      from_date: payload.fromDate || payload.from_date || payload.date,
      to_date: payload.toDate || payload.to_date || payload.date,
      company_id: payload.company && payload.company !== 'All' && Number(payload.company) > 0 ? Number(payload.company) : undefined,
      branch_id: payload.branch && payload.branch !== 'All' && Number(payload.branch) > 0 ? Number(payload.branch) : undefined,
      dept_id: payload.department && payload.department !== 'All' && Number(payload.department) > 0 ? Number(payload.department) : undefined,
      emp_id: payload.employee && payload.employee !== 'All' && Number(payload.employee) > 0 ? Number(payload.employee) : undefined,
      emp_group_id: payload.group && payload.group !== 'All' && Number(payload.group) > 0 ? Number(payload.group) : undefined,
      gender: payload.gender && payload.gender !== 'All' ? payload.gender : undefined,
    };
    const { data } = await api.post('/payroll/daily-process/run', body);
    return data;
  },

  rollbackDailyAttendance: async (payload) => {
    const body = {
      from_date: payload.fromDate || payload.from_date || payload.date,
      to_date: payload.toDate || payload.to_date || payload.date,
      company_id: payload.company && payload.company !== 'All' && Number(payload.company) > 0 ? Number(payload.company) : undefined,
      branch_id: payload.branch && payload.branch !== 'All' && Number(payload.branch) > 0 ? Number(payload.branch) : undefined,
      dept_id: payload.department && payload.department !== 'All' && Number(payload.department) > 0 ? Number(payload.department) : undefined,
      emp_id: payload.employee && payload.employee !== 'All' && Number(payload.employee) > 0 ? Number(payload.employee) : undefined,
      emp_group_id: payload.group && payload.group !== 'All' && Number(payload.group) > 0 ? Number(payload.group) : undefined,
      gender: payload.gender && payload.gender !== 'All' ? payload.gender : undefined,
      attendance_status: payload.attendance && payload.attendance !== 'All' ? payload.attendance : undefined,
    };
    const { data } = await api.post('/payroll/daily-process/rollback', body);
    return data;
  },

  updateAttendanceRecord: async (id, payload) => {
    const { data } = await api.put(`/payroll/daily-process/${id}`, payload);
    return data;
  },

  deleteRecord: async (id) => {
    const { data } = await api.delete(`/payroll/daily-process/${id}`);
    return data;
  },
};
